export var mutations = {
    setLoading: function (state, payload) {
        state.loading = payload;
    },
    setGroups: function (state, payload) {
        state.groups = payload;
    },
};
export var types = {
    USER_GROUP_LOADING: 'setLoading',
    SET_USER_GROUPS: 'setGroups',
};
